"use client";

import React from "react";

interface ContactCardProps {
  title: string;
  children: React.ReactNode;
}

export const ContactCard: React.FC<ContactCardProps> = ({
  title,
  children,
}) => (
  <div className="py-4 flex flex-col gap-3 w-full lg:py-6">
    <h3 className="text-xl font-bold font-switzer text-zinc-900 dark:text-white">
      {title}
    </h3>
    <div>{children}</div>
  </div>
);
